import {
  anUpdateThreatIntelItem,
  mockUpdateThreatIntelItemOperationMutation,
} from '__generated__';

export const getUpdateThreatIntelItemOperation = ({ value, description }) => {
  return mockUpdateThreatIntelItemOperationMutation((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        updateThreatIntelItem: {
          __typename: 'UpdateThreatIntelItem',
          data: {
            __typename: 'ThreatIntelItem',
            active: true,
            expiration: '2023-05-19T16:28:19',
            id: 'eae639a700063eff884a39363c977e243a08ee3',
            meta: {
              description: description,
              __typename: 'ItemMeta',
            },
            value: value,
          },
          finishedProcessing: true,
        },
      })
    );
  });
};

export const handlers = [
  mockUpdateThreatIntelItemOperationMutation((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        updateThreatIntelItem: anUpdateThreatIntelItem(),
      })
    );
  }),
];
